<template>
    <div class="container">
        <div class="pageTitle">仓库设置</div>

        <el-button type="primary" @click="add()" style="width: 100px;height: 40px;margin: 20px">添加仓库</el-button>
        <el-form ref="form" :model="form" label-width="100px" :inline="true" class="mt20">
            <el-form-item label="关键词:">
                <el-input v-model="form.keywords" clearable placeholder="仓库名称,仓库编号,仓库地址,负责人" style="width: 300px;"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="onSearch()">搜索</el-button>
            </el-form-item>
        </el-form>
        <!--表格-->
        <el-table
                ref="multipleTable"
                v-loading="loading"
                :data="tableData"
                height="350"
                border
                style="width: 100%">
            <el-table-column
                    prop="id"
                    label="ID"
                    width="120"
                    fixed>
            </el-table-column>
            <el-table-column
                    prop="warehouse_name"
                    label="仓库名称"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="warehouse_sn"
                    label="仓库编号"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="warehouse_address"
                    label="仓库地址"
                    width="120"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="principal"
                    label="负责人"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="remarks"
                    label="备注"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop=""
                    label="操作"
                    width="120"
                    show-overflow-tooltip>
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click="edit(scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click="del(scope.row)">删除</el-button>
                </template>
            </el-table-column>


        </el-table>
        <!--分页-->
        <el-pagination
                style="margin: 20px 0"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="pageNo"
                :page-sizes="[20, 50, 100, 200]"
                :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="totalSize">
        </el-pagination>
    </div>

</template>

<script>
    import { Message } from 'element-ui';
    export default {
        name: "instock-setting",
        data() {
            return {
                form: {
                    keywords: ''
                },
                tableData: [],
                //分页
                pageNo: 1,
                pageSize: 20,
                totalSize: 0,
                loading:false,
            }
        },
        methods: {
            onSearch() {
                this.loading = true;
                this.$get('logistics', '/warehouses', {
                    lang: '',
                    keywords: this.form.keywords,
                    per_page: this.pageSize,
                    page: this.pageNo
                }).then(res => {
                    this.loading = false;
                    this.tableData = res.data;
                    this.totalSize = res.meta.total;
                }).catch(function (error) {
                    this.loading = false;
                });
            },
            add() {
                this.$router.push({
                    name: 'addStock'
                });
            },
            edit(row) {
                this.$router.push({
                    name: 'addStock',
                    query:{
                        warehouse:row.warehouse_sn
                    }
                });
            },
            del(row) {
                this.$confirm('是否删除?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let str = row.warehouse_sn,
                        url = '/warehouses/' + str;
                    this.$delete('logistics',url, {
                    }).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.onSearch();
                    }).catch(function (error) {
                        Message.error(error)
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });

            },
            /*分页*/
            handleSizeChange(val) {
                this.pageSize = val;
                this.pageNo = 1;
                this.onSearch();
            },
            handleCurrentChange(val) {
                this.pageNo = val;
                this.onSearch();
            },

        },
        created() {
            this.onSearch();
        },
    }
</script>

<style lang="scss" scoped>

</style>